import { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useLiterals } from '~/components/Literals'
import actions, { TYPES } from '../actions'
import api from '../api'
import { getLocaleParam, getLocalStorageWithExpiry } from '../utils'

function IndexPage({ config, position, location }) {
  const dispatch = useDispatch()
  const history = useHistory()
  const productsRedux = useSelector((state) => state.app.products, shallowEqual)
  const { getLiteral } = useLiterals()

  const userLocaleRef = useRef('')
  const [localeReady, setLocaleReady] = useState(false)

  useEffect(() => {
    async function resolveLocale() {
      const fromUrl = getLocaleParam(location.search)?.locale
      if (fromUrl) {
        userLocaleRef.current = fromUrl
        setLocaleReady(true)
        return
      }

      if (config.language && config.language !== 'pt-BR') {
        try {
          const fromIp = await api.getLocationFromIP('gfnd.region:location')
          if (fromIp?.language) {
            userLocaleRef.current = fromIp.language
            setLocaleReady(true)
            return
          }
        } catch (err) {
          console.warn('Erro ao obter localização via IP:', err)
        }

        userLocaleRef.current = config.language
        setLocaleReady(true)
        return
      }

      userLocaleRef.current = 'pt-BR'
      setLocaleReady(true)
    }

    resolveLocale()
  }, [location.search, config.language])

  const getProducts = async (cnpj, userLocale) => {
    dispatch(actions.products.start())
    try {
      const products = await api.getProducts(cnpj, userLocale)
      dispatch(actions.products.success(products))
    } catch (error) {
      dispatch(
        actions.snack.add({
          id: Date.now(),
          message: getLiteral('1995')
        })
      )
      dispatch(actions.products.error())
    }
  }

  useEffect(() => {
    // reset
    dispatch(
      actions.updateApp({
        searchProductResults: null,
        currentProduct: null,
        stores: null,
        storesFetched: false,
        q: '',
        view: config.isOndetem
          ? TYPES.VIEW_HOME_PAGE
          : config.hideProductsList || config.all || config.partner || config.isDistributor
          ? TYPES.VIEW_EMPTY
          : config.showContextViewStore
          ? TYPES.VIEW_STORES
          : TYPES.VIEW_PRODUCTS
      })
    )

    document.title =
      config.brandName === 'Ondetem.App'
        ? getLiteral('2097')
        : `${getLiteral('2031')} ${config.brandName}`
  }, [location.key])

  useEffect(() => {
    if (!config.generic) {
      if (
        localeReady &&
        config.cnpj &&
        !config.hideProductsList &&
        !productsRedux &&
        !config.isDistributor
      ) {
        getProducts(config.cnpj, userLocaleRef.current)
      }
    }
  }, [config.cnpj, localeReady, productsRedux])

  useEffect(() => {
    if ((!config.generic && !position.fetched) || (config.isOndetem && !position.fetched)) {
      // if (!config.isOndetem && location !== '/') position.fetchPosition()

      if (config.showContextViewStore) {
        history.replace('/produto/todos')
        return
      }

      if (config.gtin) {
        history.replace('/produto/' + (config.gtin === 'all' ? 'todos' : config.gtin))
      } else if (config.q) {
        history.replace('/busca?q=' + config.q)
      }
    }
  }, [position.fetched])

  return null
}

export default IndexPage
